import { useEffect } from "react";
import { useSidebar } from "@/components/ui/sidebar";

export function AutoCollapseSidebar({
  shouldCollapse,
}: {
  shouldCollapse: boolean;
}) {
  const { setOpen } = useSidebar();

  useEffect(() => {
    setOpen(!shouldCollapse);
  }, [shouldCollapse]);

  return null;
}
